// extracted by mini-css-extract-plugin
module.exports = {"container":"Section_container__2N5FI","actions":"Section_actions__2kaNs","action":"Section_action__1SWk-","header":"Section_header__z5Nej","icon":"Section_icon__16eQz"};